<div #wrapper style="position: relative;" (mousedown)="bringToFront()">
    <div class="right-side-close-container">
        <div class="right-side-close button-list dialog-list">
            <button
                    *ngIf="data.refreshAction"
                    (click)="refresh()"
                    type="button"
                    aria-label="Refresh this panel"
                    matTooltip="Refresh this panel"
                    mat-icon-button><mat-icon>refresh</mat-icon>
                <mat-progress-spinner [diameter]="50" mode="indeterminate" *ngIf="loading"></mat-progress-spinner>
            </button>
            <button *ngIf="this.enableMultiWindow"
                    mat-icon-button
                    class="drag-handle"
                    type="button"
                    cdkDrag
                    cdkDragRootElement=".cdk-overlay-pane"
                    cdkDragHandle>
                <mat-icon>drag_handle</mat-icon>
            </button>
            <button
                    (click)="close()"
                    type="button"
                    mat-icon-button
                    aria-label="Close this panel"
                    matTooltip="Close this panel"
            ><mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <h4 matDialogTitle [innerHTML]="data.title | safeHtml" #dialogTitle></h4>
    <app-loading-wrapper [loading]="loading">
        <div mat-dialog-content [ngClass]="{'resizable' : true}" #resizable>
            <div class="row">
                <div class="column">
                    <div *ngComponentOutlet="data.component; injector: data.injector"></div>
                </div>
            </div>
        </div>
    </app-loading-wrapper>
</div>
